<div class="t-popup-body" style="overflow: auto;width:80em;" [formGroup]="gfs.Form"  >
    <button class="t-btn-popup-close" aria-label="close popup" (click)="close(true)"></button>
    <div class="formHeader">
        <h2 style="align-self: center;">
           Course Of Exam
        </h2>
        <span  class="icon-print" (click)="printForm()" style="margin-inline-end: 1.5em;" aria-label="Print" matTooltip="Print"><img src="../../../assets/icons/print.svg"></span>
    </div>
    <div class="m-box">

        <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between;">
            <section class="w100" style="direction: rtl; justify-content: space-evenly; display: flex;">
                <span>זיהוי מטופל <input type="checkbox" formControlName="PatientIdentification"></span>
                <span> בדיקות לביצוע:</span>
                <span>קולונוסקופיה <input type="checkbox" formControlName="Colonoscopy"></span>
                <span>גסטרוסקופיה <input type="checkbox" formControlName="Gastroscopy"></span>
                <span>סיגמואידוסקופיה <input type="checkbox" formControlName="Sigmoidoscopy"></span>
            </section>
           
        </div>
    <div class="m-box rtl" [formGroup]="SignForm">
        <h2>סימנים חיוניים</h2>
        <div>
            <span class="l-flex-w" style="width: 100%;padding: 5px 0;">
                <label class="t-label-top">
                    <span class="f-label-span">לחץ דם</span>
                    <span class="t-field t-field--number" style="direction: ltr;">
                        <input class="t-field-text" type="number" min="0" formControlName="bpSystolic"
                            style='width: 3em;text-align: center;text-align-last: center;' />/<input
                            class="t-field-text" type="number" min="0" formControlName="bpDyastolic"
                            style='width: 3em;text-align: center;text-align-last: center;'>
                        <span class="t-field-desc" style="padding: 0.3em;">
                            mmHg
                        </span>
                    </span>
                </label>
                <label class="t-label-top">
                    <span class="f-label-span">
                        דופק
                    </span>
                    <span class="t-field t-field--number">
                        <span class="t-field-desc">bpm</span>
                        <input type="text" name="placenta_TEMP_name" class="t-field t-field-text"
                            style="margin-inline-start: 10px;" formControlName="Pulse">
                    </span>
                </label>
                <label class="t-label-top">
                    <span class="f-label-span">
                        סטורציה
                    </span>
                    <span class="t-field t-field--number">
                        <span class="t-field-desc">%</span>
                        <input type="text" name="placenta_TEMP_name" class="t-field t-field-text"
                            style="margin-inline-start: 10px;" formControlName="Saturation">
                    </span>
                </label>
                <label class="t-label-top">
                    <span class="f-label-span">
                       זמן מדידה
                    </span>
                    <span class="t-field t-field--number">
                        <input type="text" placeholder="min" name="placenta_TEMP_name" class="t-field t-field-text"
                        style="margin-inline-start: 10px;" formControlName="Min">:
                        <input type="text" name="placenta_TEMP_name" class="t-field t-field-text"
                            style="margin-inline-start: 10px;" formControlName="Hour" placeholder="hour">
                           
                    </span>
                </label>
                <button class="btnAdd" (click)="saveSigns()">הוספה</button>
            </span>
        </div>
        <div class="m-box w50" *ngIf="Signs.length > 0">
            <table class="l-table">
                <tr class="l-row header">
                    <td class="l-td center">שעה</td>
                    <td class="l-td center">לחץ דם</td>
                    <td class="l-td center">דופק</td>
                    <td class="l-td center">סטורציה</td>
                 
                </tr>
                <tr class="l-row" *ngFor="let sign of Signs">
                    <td class="l-td center">{{sign.CreationTime | date: 'HH:mm'}}</td>
                    <td class="l-td center">{{sign.bpSystolic}}/{{sign.bpDyastolic}}mmHg</td>
                    <td class="l-td center">{{sign.Pulse}}bpm</td>
                    <td class="l-td center">{{sign.Saturation}}%</td>
                </tr>
            </table>
        </div>
    </div>
    <ng-container [formGroup]="gfs.Form">
        <div class="m-box w100 rtl" >
            <div style="display: flex;">
                <label class="t-label-top">
                    <span style="width: 8em;">שעת התחלת הבדיקה:</span>
                    <span class="t-field t-field--number" style="direction: ltr;">
                        <p class="t-field-text">{{gfs.Form.get("CreationTime").value |date:'HH:mm' }}</p>
            
                    </span>
                </label>
                <label class="t-label-top">
                    <mat-form-field>
                        <mat-label [ngClass]="['mat-select-value']"> סוג מכשיר</mat-label>
                        <mat-select [formControl]="this.gfs.Form.get('DeviceType')" multiple [ngClass]="['mat-select-value','mat-form-field']">
                          <mat-option  value="גסטרו" [ngClass]="['mat-select-value']">גסטרו</mat-option>
                          <mat-option  value="קולונו" [ngClass]="['mat-select-value']">קולונו</mat-option>
                         
                        </mat-select>
                      </mat-form-field>
                </label>
                <label class="t-label-top">
                    <span style="width: 6em;"> מספר מכשיר</span>
                    <span class="t-field t-field--number" >
                        <input class="t-field t-field-text" type="number"  formControlName="DeviceNumber" />
                    </span>
                </label>
            </div>
            <div style="display:flex">
                <label class="t-label-top">
                    <span style="width: 8em;">סדציה</span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;" (dblclick)="gfs.Form.get('Sedation').setValue(-1);gfs.Form.get('MedicationType').setValue('')">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Sedation" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Sedation" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא 
                            </span>

                        </label>
                    </div>
                </label>

                <mat-form-field *ngIf="gfs.Form.get('Sedation').value==1">
                    <mat-label [ngClass]="['mat-select-value']"> בחר סוג/י חומר/ים</mat-label>
                    <mat-select [formControl]="this.gfs.Form.get('MedicationType')" multiple [ngClass]="['mat-select-value','mat-form-field']">
                      <mat-option  value="ביאטריל" [ngClass]="['mat-select-value']">ביאטריל</mat-option>
                      <mat-option  value="דורמיקום" [ngClass]="['mat-select-value']">דורמיקום</mat-option>
                      <mat-option  value="פרופופול" [ngClass]="['mat-select-value']">פרופופול</mat-option>
                    </mat-select>
                  </mat-form-field>
                <label class="t-label-top">
                    <div *ngIf="gfs.Form.get('Sedation').value>-1 && gfs.Form.get('Sedation').value">
                        <input class="t-field t-field-text" type="text" placeholder="פירוט" formControlName="MedicationText" />
                    </div>
                </label>
            </div>
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">ביופסיה</span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;" (dblclick)="gfs.Form.get('Byopsy').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Byopsy" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                נלקח
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Byopsy" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                 לא נלקח
                            </span>

                        </label>
                    </div>
                </label>

            </div>
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;"> פוליפאקטומי </span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;" (dblclick)="gfs.Form.get('Polypectomy').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Polypectomy"
                                [value]="1"><i class="customInput-display"></i>

                            <span>
                                בוצע
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Polypectomy"
                                [value]="0"><i class="customInput-display"></i>

                            <span>
                                לא בוצע
                            </span>

                        </label>
                    </div>
                </label>
            </div>
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">אוראז טסט ׂׂ(HP)</span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;width: 90%;" (dblclick)="gfs.Form.get('HpTaken').setValue(-1);gfs.Form.get('HpResult').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="HpTaken" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                נלקח
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="HpTaken" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא נלקח
                            </span>

                        </label>

                        <label class="observe" *ngIf="gfs.Form.get('HpTaken').value>-1 && gfs.Form.get('HpTaken').value">

                            <input type="radio" class="custom-check customInput" formControlName="HpResult" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                חיובי
                            </span>
                        </label>

                        <label class="not-observed" *ngIf="gfs.Form.get('HpTaken').value>-1 && gfs.Form.get('HpTaken').value">

                            <input type="radio" class="custom-check customInput" formControlName="HpResult" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                שלילי 
                            </span>

                        </label>
                    </div>
                </label>

            </div>
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">סימון בדיו SPOT  </span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;" (dblclick)="gfs.Form.get('Spot').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Spot"
                                [value]="1"><i class="customInput-display"></i>

                            <span>
                                בוצע
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Spot"
                                [value]="0"><i class="customInput-display"></i>

                            <span>
                                לא בוצע
                            </span>

                        </label>
                    </div>
                </label>
            </div>
            
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">שימוש בפלטה</span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;" (dblclick)="gfs.Form.get('Plate').setValue(-1);gfs.Form.get('PlateText').setValue('')">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Plate" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Plate" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                    </div>
                    <div *ngIf="gfs.Form.get('Plate').value">
                        <span>
                            מיקום הפלטה:
                        </span>
                        <input class="t-field t-field-text" formControlName="PlateText" />
                    </div>
                </label>
            </div>
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">למטופל וריד פתוח </span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;" (dblclick)="gfs.Form.get('OpenVein').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="OpenVein" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="OpenVein" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                    </div>
                </label>
            </div>
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">המטופל/ת מקבל/ת חמצן במשקפיים/מסכה   </span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;"  (dblclick)="gfs.Form.get('receivesOxygen').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="receivesOxygen" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="receivesOxygen" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                    </div>
                </label>
            </div>
            <!-- <div>
                <label class="t-label-top">
                    <span style="width: 8em;">מצב העור לפני</span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="SkinBefore"
                                [value]="1"><i class="customInput-display"></i>

                            <span>
                                תקין
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="SkinBefore"
                                [value]="0"><i class="customInput-display"></i>

                            <span>
                                לא תקין
                            </span>

                        </label>
                    </div>
                </label>
            </div>
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">מצב העור אחרי</span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="SkinAfter"
                                [value]="1"><i class="customInput-display"></i>

                            <span>
                                תקין
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="SkinAfter"
                                [value]="0"><i class="customInput-display"></i>

                            <span>
                                לא תקין
                            </span>

                        </label>
                    </div>
                </label>
            </div> -->
            <div style="padding-top: 1%;">
                <label class="t-label-top">
                    <span style="width: 8em;">מהלך פעולה</span>
                    <div class="anatomy-twin-radios" style="margin-top: 0;" (dblclick)="gfs.Form.get('DuringProc').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="DuringProc"
                                [value]="1"><i class="customInput-display"></i>

                            <span>
                                תקין
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="DuringProc"
                                [value]="0"><i class="customInput-display"></i>

                            <span>
                                לא תקין
                            </span>

                        </label>
                    </div>
                    <div style="display: flex;align-items: center;">
                        <span style="margin-left: 3em;">
                           תיאור הפעולה:
                        </span>
                       
                        <textarea class=" m-box fulltext scroller scroller-intro fulltext textarea" style="width: 20em;" formControlName="DuringProcText"></textarea>
                    
                    </div>
                </label>
            </div>
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">מדד כאב 0-10: </span>
                    <div class="l-flex-c l-flex-w indicative-fieldset" style="flex-wrap: inherit;direction: rtl;" (dblclick)="gfs.Form.get('PainLevel').setValue('')">

                        <label class="t-label-top">
                            <input type="radio" formControlName="PainLevel" value="painless" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                אין כאב בכלל
                            </span>
                        </label>
                        <label class="t-label-top">
                            <input type="radio" formControlName="PainLevel" value="lowPain" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                כאב מועט
                            </span>
                        </label>
        
                        <label class="t-label-top">
                            <input type="radio" formControlName="PainLevel" value="mediumPain" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                כאב בינוני
                            </span>
                        </label>
        
                        <label class="t-label-top">
                            <input type="radio" formControlName="PainLevel" value="strongPain" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                כאב חזק
                            </span>
                        </label>
        
                        <label class="t-label-top">
                            <input type="radio" formControlName="PainLevel" value="fullPain" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                כאב בלתי נסבל
                            </span>
                        </label>
                    </div>
                </label>
            </div>
           
            <div>
                <label class="t-label-top">
                    <span style="width: 8em;">שעת סיום הבדיקה:</span>
                    <input class="t-field" type="time" formControlName="EndTime" />
                </label>
            </div>
            <div style="display: flex;
            flex-direction: row;
            justify-content: space-between;align-items: center;">
            <div style="display: grid;place-self: center;">
        <span>חתימת האח/ות:</span>
        <canvas id="canvasDoc" #canvasSign [style.border]="'1px solid black'"  [ngClass]="'can-shadow'" width="200" height="100"   (click)="setCanvas()"></canvas>
        <button   style="position: relative;top: -2em;width: fit-content;" (click)="clearSign()">                                            
            <ng-container>
                <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
            </ng-container>
        </button>

    </div>
    <button class="patient-ob-btn -blankbutton" (click)="close(true)">Save and Close</button>
        <button class="patient-ob-btn -barcode" (click)="showScanPopup = true">Scan Barcodes</button>
        <ng-container *ngIf="showScanPopup">
            <app-pathology-scan-popup
                (close)="showScanPopup = false"
            ></app-pathology-scan-popup>
        </ng-container>
                                
    </div>
        </div>
    </ng-container>

</div>